// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"60bcc066","296":"8ecc3682","481":"6061897f"}[chunkId] + ".chunk.js";
};